var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',[_c('section',[_c('br'),_c('section',{attrs:{"id":"firebaseui-auth-container"}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }